// Retry only opted-in autoplay videos when their visible presentation is ready.
function initTeaserAutoplay() {
    document.querySelectorAll('.bg-image-container video[autoplay]').forEach(video => {
        if (video.dataset.teaserAutoplayBound) return;
        video.dataset.teaserAutoplayBound = 'true';
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        let pending = false;
        const start = () => {
            if (document.hidden || pending || video.ended || !video.paused) return;
            const rect = video.getBoundingClientRect();
            if (!rect.width || !rect.height || rect.bottom <= 0 || rect.top >= innerHeight) return;
            for (let node = video; node; node = node.parentElement) {
                const style = getComputedStyle(node);
                if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return;
            }
            pending = true;
            video.play().then(() => {
                delete video.dataset.autoplayError;
            }).catch(error => {
                video.dataset.autoplayError = error.name;
            }).finally(() => { pending = false; });
        };
        const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) start();
        });
        observer.observe(video);
        const visibilityObserver = new MutationObserver(start);
        for (let node = video.parentElement; node && node !== document.body; node = node.parentElement) {
            visibilityObserver.observe(node, { attributes: true, attributeFilter: ['style', 'class'] });
        }
        video.addEventListener('loadeddata', start);
        video.addEventListener('canplay', start);
        const container = video.closest('.bg-image-container');
        container.addEventListener('animationend', start);
        container.addEventListener('transitionend', start);
        window.addEventListener('pageshow', start);
        document.addEventListener('visibilitychange', start);
        requestAnimationFrame(start);
    });
}

document.addEventListener('DOMContentLoaded', initTeaserAutoplay);
document.addEventListener('shopify:section:load', initTeaserAutoplay);
